export default "__VITE_ASSET__57d6d45c__"